/** Packages **/
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { DefaultButton } from '../Buttons';
// Styles
import './styles.scss';

const MoreButton = withStyles({
  root: {
    borderRadius: '100%',
    border:'none',
    '&:disabled': {
      color: '#ADADAD',
      borderColor: '#ADADAD',
      cursor: 'not-allowed',
      '& svg': {
        color: '#ADADAD',
      },
    },
  },
})(DefaultButton);

const CardHead = (props) => {
 const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const allOptionsDisabled = props.options.every(option => option.disabled);
  
  // Create a unique key based on disabled states to force re-render
  const optionsKey = props.options.map(opt => `${opt.key || opt.label}-${opt.disabled}`).join('|');

  const options = props.options.map((option, index) => {
    return (
      <MenuItem 
        key={`${option.key || index}-${option.disabled}`} 
        onClick={option.disabled ? undefined : option.func}
        disabled={option.disabled}
        style={option.disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
      >
        {option.label}
      </MenuItem>
    );
  });
  const menu = (
    <Menu
      key={`menu-${optionsKey}`}
      id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        onClick={() => handleClose()}
    >
      {options}
    </Menu>);
  return (
    <div>
      <div className={`CardHead ${props.headClassName}`}>
        <div className=" cardHead-menuContainer">
          {(props.hasMenu && props.options.length > 0) && <div>
            <MoreButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={(e) => handleClick(e)}
              disabled={allOptionsDisabled}
            >
              {props.menuIconType === 'delete' ? props.readOnly ? '' : <DeleteSweepIcon /> : <MoreVertIcon />}
            </MoreButton>
            {menu}
          </div> }
        </div>
        <div>
          <h1 style={props.titleStyle}>{props.title}</h1>
          {props.subtitle ? <h2 className={props.subtitleClassName}>{props.subtitle}</h2> : null}
        </div>
        <div className="rightElement">{props.rightElement}</div>
        {props.rightIcon ? <div className="rightElement"><i className={props.rightIcon} /></div> : null}
      </div>
    </div>
  );
};

CardHead.propTypes = {
  hasMenu: PropTypes.bool,
  headClassName: PropTypes.string,
  menuIconType: PropTypes.string,
  options: PropTypes.array,
  rightElement: PropTypes.any,
  rightIcon: PropTypes.string,
  subtitle: PropTypes.string,
  subtitleClassName: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  titleStyle: PropTypes.object,
  defaultSettings: PropTypes.bool,
  handleOpenImportDialog: PropTypes.func,
  readOnly: PropTypes.bool,
};

CardHead.defaultProps = {
  hasMenu: false,
  headClassName: '',
  menuIconType: '',
  options: [],
  rightElement: '',
  rightIcon: '',
  subtitle: '',
  subtitleClassName: '',
  title: '',
  titleStyle: {},
  defaultSettings: false,
  handleOpenImportDialog: null,
  readOnly: false,
};

export default (CardHead);
